import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface SurveyEmoji2Props {
  color?: string;
  style?: React.CSSProperties;
}

export const SurveyEmoji2Icon = ({ color = RoutalPalette.white, style = {}, ...props }: SurveyEmoji2Props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 58 59" style={{ width: `58px`, height: `59px`, ...style }}>
      <circle cx="29.0391" cy="29.4424" r="15" fill="#FEC654" />
      <path
        d="M32.0447 26.6167C32.0379 26.6167 32.0311 26.6167 32.0234 26.6167C30.6744 26.6167 29.4602 27.09 28.7736 27.8842C28.4148 28.2993 28.4594 28.9258 28.8744 29.2846C29.0626 29.4475 29.2934 29.5271 29.5242 29.5271C29.8025 29.5271 30.0789 29.4107 30.2748 29.1838C30.526 28.8938 31.1632 28.6029 32.0234 28.6029C32.0282 28.6029 32.0331 28.6029 32.037 28.6029C32.8865 28.6058 33.5285 28.8928 33.7884 29.175C34.1608 29.5804 34.7883 29.6056 35.1917 29.2342C35.5951 28.8628 35.6223 28.2353 35.2509 27.8309C34.5565 27.0754 33.3578 26.6215 32.0447 26.6167Z"
        fill="#4D4D4D"
      />
      <path
        d="M36.84 20.3623H32.5099C31.961 20.3623 31.5168 20.8065 31.5168 21.3554C31.5168 21.9043 31.961 22.3484 32.5099 22.3484H33.8908C33.8713 22.5089 33.8608 22.6749 33.8608 22.845C33.8608 24.2161 34.5277 25.3277 35.3504 25.3277C36.1731 25.3277 36.84 24.2161 36.84 22.845C36.84 22.6749 36.8296 22.5089 36.81 22.3484H36.84C37.3889 22.3484 37.8331 21.9043 37.8331 21.3554C37.8331 20.8065 37.3889 20.3623 36.84 20.3623ZM28.8655 22.3484H28.8955C29.4444 22.3484 29.8885 21.9043 29.8885 21.3554C29.8885 20.8065 29.4444 20.3623 28.8955 20.3623H24.5653C24.0164 20.3623 23.5723 20.8065 23.5723 21.3554C23.5723 21.9043 24.0164 22.3484 24.5653 22.3484H25.9463C25.9267 22.5089 25.9163 22.6749 25.9163 22.845C25.9163 24.2161 26.5832 25.3277 27.4059 25.3277C28.2286 25.3277 28.8955 24.2161 28.8955 22.845C28.8955 22.6749 28.885 22.5089 28.8655 22.3484Z"
        fill="#4D4D4D"
      />
    </SvgIcon>
  );
};
